import type { Locale } from '@/i18n/types'

export const TRY_NOW_CTAS = [
  'home_nav',
  'landing_nav',
  'landing_nav_mobile',
  'home_hero',
  'home_final',
  'pricing_plans',
  'pricing_page',
  'referee_cta',
  'landing_hero',
  'landing_final',
  'pricing_closing',
  'pending_approval',
  'features_page',
  'feature_category',
  'features_mcp',
] as const

export type TryNowCta = (typeof TRY_NOW_CTAS)[number]

export function tryNowPath(locale: Locale, cta?: TryNowCta): string {
  const path = locale === 'en' ? '/try' : `/${locale}/try`
  return cta ? `${path}?cta=${cta}` : path
}
